import { useEffect } from "react";

export const useDebouncedEffect = (effect, deps, delay) => {
  useEffect(() => {
    const handler = setTimeout(() => effect(), delay);

    return () => {
      clearTimeout(handler);
    };
  }, [...deps, delay]);
}
